module.exports = __webpack_public_path__ + "img/nav_deposit.12c47cdd.png";